import * as Sentry from "@sentry/react";
import { HeadContent, Scripts, createRootRoute } from "@tanstack/react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
import { AuthNav } from "#/components/AuthNav";
import { PostHogProvider } from "#/components/PostHogProvider";
import { fetchAuthUserServer } from "#/lib/auth-server-fn";
import "#/styles.css";

export const Route = createRootRoute({
  head: () => ({
    meta: [
      { charSet: "utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      { title: "Ineya" },
    ],
    links: [
      { rel: "icon", type: "image/svg+xml", href: "/favicon.svg" },
      { rel: "apple-touch-icon", href: "/favicon.svg" },
      { rel: "manifest", href: "/manifest.json" },
      {
        rel: "preconnect",
        href: "https://fonts.googleapis.com",
      },
      {
        rel: "preconnect",
        href: "https://fonts.gstatic.com",
        crossOrigin: "anonymous",
      },
      {
        rel: "stylesheet",
        href: "https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;1,300&family=DM+Sans:wght@300;400;500&display=swap",
      },
    ],
  }),
  loader: async () => {
    const user = await fetchAuthUserServer();
    return { user };
  },
  shellComponent: RootDocument,
});

function ErrorFallback() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-6 text-center">
      <h1 className="mb-2 font-serif text-2xl">Something went wrong</h1>
      <p className="text-sm text-muted-foreground">
        Please refresh the page and try again.
      </p>
    </div>
  );
}

function RootDocument({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <html lang="en">
      <head>
        <HeadContent />
      </head>
      <body style={{ margin: 0 }}>
        <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
          <PostHogProvider>
            <QueryClientProvider client={queryClient}>
              <AuthNav />
              {children}
            </QueryClientProvider>
          </PostHogProvider>
        </Sentry.ErrorBoundary>
        <Scripts />
      </body>
    </html>
  );
}
